import { Component, OnInit } from '@angular/core';
// import {
//   NgcCookieConsentService,
//   NgcNoCookieLawEvent,
//   NgcInitializeEvent,
 
//   NgcStatusChangeEvent,
// } from "ngx-cookieconsent";
import { Subscription } from "rxjs";
//  import "../../../../../node_modules/cookieconsent/build/cookieconsent.min.js"

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  private popupOpenSubscription: Subscription;
  private popupCloseSubscription: Subscription;
  private initializeSubscription: Subscription;
  private statusChangeSubscription: Subscription;
  private revokeChoiceSubscription: Subscription;
  private noCookieLawSubscription: Subscription;
  constructor() {

  
   }



  ngOnInit(): void {

  } 


  ngOnDestroy() {
    // unsubscribe to cookieconsent observables to prevent memory leaks
    // this.popupOpenSubscription.unsubscribe();
    // this.popupCloseSubscription.unsubscribe();
    // this.initializeSubscription.unsubscribe();
    // this.statusChangeSubscription.unsubscribe();
    // this.revokeChoiceSubscription.unsubscribe();
    // this.noCookieLawSubscription.unsubscribe();
  }
  

}
